import Device from '../Device';
import vp from '../../../services/api/vp';

const questions = [{
  type: 'honeywell-app-enrollment',
  name: 'honeywellAppEnrollment',
  model: 'honeywellAppEnrollment',
  show: true,
  active: true,
  mfg: 'honeywell',
  validation: 'required',
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const Honeywell = new Device('honeywell', { mfg: 'honeywell', questions, addDevice });

export default Honeywell;
